module.exports = "/virtual-football-league/img/amblems/right/logos/GETAFE.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/GETAFE.png
// module id = 2199
// module chunks = 4